import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiHeart, FiBookOpen, FiMessageSquare, FiShield } = FiIcons;

const practiceCards = [
  {
    icon: FiHeart,
    title: 'Coach',
    copy: 'Help students keep their own voice at the center of the essay.'
  },
  {
    icon: FiBookOpen,
    title: 'Recruiter',
    copy: 'Explain the Common App baseline, then point families to each school’s admissions page for its own rules.'
  },
  {
    icon: FiMessageSquare,
    title: 'Prompt engineer',
    copy: 'Show families AI uses that ask helpful questions instead of writing the essay.'
  },
  {
    icon: FiShield,
    title: 'Key person in the room',
    copy: 'Stay calm and honest. Warn against sharing private data, and remind families to double-check money, deadline, and rule answers.'
  }
];

const steps = [
  ['01', 'Allow your microphone and click start.'],
  ['02', 'Talk with the parent for about 8 to 10 minutes.'],
  ['03', 'Get a debrief with scores and one thing to try next time.']
];

function PracticeCard({ item, index }) {
  return (
    <motion.article
      className="practice-card"
      initial={{ opacity: 0, y: 14 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.45, delay: index * 0.08 }}
    >
      <span className="card-icon"><SafeIcon icon={item.icon} aria-hidden="true" /></span>
      <h3>{item.title}</h3>
      <p>{item.copy}</p>
    </motion.article>
  );
}

function ProgramSections() {
  return (
    <>
      <section className="scene-section">
        <div className="scene-inner">
          <span className="eyebrow">The scene</span>
          <p>
            A mom and her son sit at the kitchen table. The essay box is empty. He typed one question into an AI chatbot to get unstuck, and now neither of them knows if that counts as cheating. You’re the counselor they came to see.
          </p>
        </div>
      </section>
      <section className="practice-section section-wrap" id="what-youll-practice">
        <div className="section-heading">
          <span className="eyebrow">Your role in the room</span>
          <h2>What you’ll practice</h2>
          <p>Small, useful ways to help families move forward with confidence.</p>
        </div>
        <div className="practice-grid">
          {practiceCards.map((item, index) => (
            <PracticeCard item={item} index={index} key={item.title} />
          ))}
        </div>
      </section>
      <section className="steps-section" id="how-it-works">
        <div className="section-wrap steps-inner">
          <div className="section-heading">
            <span className="eyebrow">Simple by design</span>
            <h2>How it works</h2>
          </div>
          <div className="steps-grid">
            {steps.map(([number, text]) => (
              <div className="step-item" key={number}>
                <span className="step-number">{number}</span>
                <p>{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default ProgramSections;
